import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { router } from "./routes";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import 'antd/dist/reset.css';
import "./index.css";
import "@/hooks/stores/useTheme";
import { applyChartJsThemeDefaults } from "@/utils/chartTheme";

// Align Chart.js tooltips with current theme on startup
if (typeof window !== "undefined") {
  queueMicrotask(() => applyChartJsThemeDefaults());
}

const queryClient = new QueryClient();


ReactDOM.createRoot(document.getElementById("root")).render(
  // <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <ToastContainer 
        position="top-right" 
        autoClose={3000} 
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        toastStyle={{ 
          width: "360px",
          borderRadius: "12px",
          backgroundColor: "#101828",
          fontFamily: "'Inter', sans-serif",
          boxShadow: "0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)",
          color: "#ffffff"
        }}
      />
    </QueryClientProvider>
  // </React.StrictMode>
);
